module.exports = __webpack_public_path__ + "img/story019@2x.9df245ae.webp";